import { actionCreators } from './action';
import { connect } from 'react-redux';
import Page from './../../common/Page';

const mapStateToProps = (state) => { 
    const pageData = state.cookies && state.cookies
    return ({ pageData })   
}

function mapDispatchToProps(dispatch) {
    const callToData = () => dispatch(actionCreators.getCookies());
    return ({ callToData });
}

export default connect(mapStateToProps, mapDispatchToProps)(Page);
